import React from 'react'

const ToolbarContext = React.createContext( null )

export default ToolbarContext
